<div class="bmc-export-parent">
    <div class="bmc-export-header">
      <h3 class="bmc-export-header__text"> {{ 'SYNC_FILES.EXPORT_ENTITY_VALUES' | translate}}</h3>
      <div class="bmc-export-header__close" (click)="closeModal()">
          <svg class="bmc-export-header__close__icon">
              <use href="#icon-close"></use>
          </svg>
      </div>
    </div>
    <div class="bmc-export-content"  [ngClass]="{'bmc-export-content_loaded': !isLoading && status!=='success'}">
      <div *ngIf="status !=='error' && status !=='nodata'">
        <ng-container *ngIf="!isLoading&&status!=='success'">
          <div class="bmc-export-content_custom_message">
            <label class="bmc-export-content_custom_message__text">{{ 'SYNC_FILES.EXPORT_DETAIL_MESSAGE' | translate}}</label>
          </div>
          <div  class="bmc-export-content_search-box">
            <svg class="bz-icon-svg bz-icon-svg--16 bmc-export-content_search-box__icon">
              <use href="#icon-search"></use>
            </svg>
            <input class="bmc-export-content_search-box__text" type="text" placeholder="{{ 'SYNC_FILES.SEARCH' | translate}}" [(ngModel)]="filterValue" (ngModelChange)="onFilterValueChange($event)" >
          </div>
          <div class="bmc-export-content_tree-box">
            <treeview [nodes]="nodes" (itemSelected)="onSelectedNode($event)"></treeview>
          </div>
        </ng-container>
        <div *ngIf="isLoading" class="bmc-sync-data__loader"> 
          <bz-loading *ngIf="messageStatus==='loading'" [message]="'SYNC_FILES.LOADING'"></bz-loading>    
          <bz-loading *ngIf="messageStatus==='exporting'" [message]="'SYNC_FILES.EXPORT_FILE'"></bz-loading>
        </div>
        <div *ngIf="status==='success'" class="bmc-export-content-infodata">
          <label class="bmc-syncfiles-export-higher-text">{{ 'SYNC_FILES.EXPORT_FINISHED' | translate}}</label>
          <label class="bmc-syncfiles-export-lower-text">{{ 'SYNC_FILES.DATA_EXPORTED' | translate}}</label>
        </div>    
      </div>
      <div *ngIf="status =='nodata'" class="bmc-export-content-infodata">
        <label class="bmc-syncfiles-export-higher-text">{{ 'SYNC_FILES.NODATA_TITLE' | translate}}</label>
        <label class="bmc-syncfiles-export-lower-text">{{ 'SYNC_FILES.NODATA_MESSAGE' | translate}}</label>
      </div>
      <div *ngIf="status =='error'">
        <biz-sync-files-error-table [errorData]="filesWithError"  [status]="export"></biz-sync-files-error-table>
      </div>
    </div>
    <div class="bmc-export-footer">
      <div class="bmc-export-footer__right-container"> 
          <a (click)="onDownloadFile()" *ngIf="status =='success'">
            <bzg-icon [nameIcon]="'icon-download'" [color]="'active'">
            </bzg-icon>
          </a>     
          <bzg-button-primary *ngIf="status !=='error'&& status !=='success'" [disabled]="isSomethingSelected()|| isLoading" type="button" (click)="onExport()">{{'SYNC_FILES.EXPORT' | translate}}</bzg-button-primary>      
          <bzg-button-primary *ngIf="status =='error' || status =='success'" type="button" (click)="closeModal()">{{'SYNC_FILES.CLOSE' | translate}}</bzg-button-primary>      
      </div>
    </div>
    <a #fileLink id="fileLink" style="visibility:hidden"></a>
  </div>